import React, { FC } from 'react';
import Button, { ButtonSizes, ButtonVariants } from '@/components/new-design/Button';
import styles from './HeaderButton.module.css';
import { twMerge } from 'tailwind-merge';

interface HeaderButtonProps {
  onClick: () => void;
  icon?: React.ReactNode;
  text?: string;
  extraIcon?: string;
  className?: string;
  children?: React.ReactNode;
  id?: string;
}

const HeaderButton: FC<HeaderButtonProps> = ({ onClick, icon, text, extraIcon, className, children, id }) => {
  return (
    <div className="flex w-full cursor-pointer justify-center gap-2">
      <Button
        id={id}
        onClick={onClick}
        size={ButtonSizes.xl}
        variant={ButtonVariants.transparentWithBorder}
        className={twMerge(styles.headerButton, className)}
      >
        {icon}
        {text && <span>{text}</span>}
        {extraIcon && <img src={extraIcon} alt="extra icon" className="h-6 w-6" />}
        {children}
      </Button>
    </div>
  );
};

export default HeaderButton;
